// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__30zEl","header":"Messages_header__HX_nZ"};